import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteItemLocationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteItemLocationMutation = { __typename?: 'Mutation', deleteItemLocation: string };


export const DeleteItemLocationDocument = gql`
    mutation DeleteItemLocation($id: ID!) {
  deleteItemLocation(id: $id)
}
    `;
export type DeleteItemLocationMutationFn = Apollo.MutationFunction<DeleteItemLocationMutation, DeleteItemLocationMutationVariables>;

/**
 * __useDeleteItemLocationMutation__
 *
 * To run a mutation, you first call `useDeleteItemLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemLocationMutation, { data, loading, error }] = useDeleteItemLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteItemLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemLocationMutation, DeleteItemLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemLocationMutation, DeleteItemLocationMutationVariables>(DeleteItemLocationDocument, options);
      }
export type DeleteItemLocationMutationHookResult = ReturnType<typeof useDeleteItemLocationMutation>;
export type DeleteItemLocationMutationResult = Apollo.MutationResult<DeleteItemLocationMutation>;
export type DeleteItemLocationMutationOptions = Apollo.BaseMutationOptions<DeleteItemLocationMutation, DeleteItemLocationMutationVariables>;